import {INeighbourhood} from "../../api/Model";
import React, {useMemo} from "react";
import {NeighbourhoodGuessResultPane} from "./NeighbourhoodGuessResultPane";
import {mapSetState, SetState} from "../../util/FormHandlers";
import {SelectedNeighbourhood} from "./NeighbourhoodGuessPane";
import {HierarchyEmployee} from "../../util/EmployeeHierarchy";
import {RemoteValue} from "../../util/RemoteValue";
import {EmployeeNeighbourhood} from "../../api/EmployeeNeighbourhoodStore";

export interface GuessNeighbourhoodForm {
    employee: HierarchyEmployee;
    neighbourhood?: INeighbourhood;
}

export function GuessNeighbourhoodPicker({employeeNeighbourhoods, form, setForm}: {
    employeeNeighbourhoods: RemoteValue<EmployeeNeighbourhood>,
    form: GuessNeighbourhoodForm,
    setForm: SetState<GuessNeighbourhoodForm>,
}) {

    const selectedNeighbourhood = useMemo<SelectedNeighbourhood>(
        () => [form.neighbourhood, mapSetState(setForm, 'neighbourhood')],
        [form, setForm],
    );

    return (
        <NeighbourhoodGuessResultPane
            employee={form.employee}
            selectedNeighbourhood={selectedNeighbourhood}
            employeeNeighbourhoods={employeeNeighbourhoods}
        />
    );
}